import { Optional } from "../types";

export const SELECTED_WELLBORE_LOCAL_STORAGE_KEY = "selectedWellbore";

export const initialLocalStorageWellboreName = localStorage.getItem(
  SELECTED_WELLBORE_LOCAL_STORAGE_KEY
) as Optional<string>;
